class SizeChartModal extends HTMLElement {
  constructor() {
    super();

    // Elements
    this.openButtons = document.querySelectorAll('.sizing-chart-modal-button');
    this.modal = document.querySelector('.size-chart__modal');

    // Bind methods
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.handleTransitionEnd = this.handleTransitionEnd.bind(this);

    // Initialize
    this.init();
  }

  init() {
    if (!this.openButtons.length || !this.modal) return;

    // Add event listeners to all buttons
    this.openButtons.forEach(button => {
      button.addEventListener('click', this.openModal);
    });

    // Add close button if it doesn't exist
    if (!this.modal.querySelector('.modal-close-button')) {
      const closeButton = document.createElement('button');
      closeButton.classList.add('modal-close-button');
      closeButton.innerHTML = '×';
      closeButton.setAttribute('aria-label', 'Close size chart');
      this.modal.insertBefore(closeButton, this.modal.firstChild);
    }

    this.closeButton = this.modal.querySelector('.modal-close-button');
    this.closeButton.addEventListener('click', this.closeModal);
    this.modal.addEventListener('transitionend', this.handleTransitionEnd);
  }

  openModal() {
    this.modal.style.zIndex = '21'; // Set initial z-index
    this.modal.classList.add('active');
    document.addEventListener('click', this.handleClickOutside);
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
  }

  closeModal() {
    this.modal.classList.remove('active');
    document.removeEventListener('click', this.handleClickOutside);
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
  }

  handleTransitionEnd(event) {
    if (event.propertyName === 'opacity') {
      // Update z-index after opacity transition
      this.modal.style.zIndex = this.modal.classList.contains('active') ? '21' : '-1';
    }
  }

  handleClickOutside(event) {
    if (!this.modal.contains(event.target) &&
        ![...this.openButtons].some(button => button.contains(event.target))) {
      this.closeModal();
    }
  }

  // Lifecycle callbacks
  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    // Clean up event listeners when element is removed
    this.openButtons?.forEach(button => {
      button.removeEventListener('click', this.openModal);
    });
    this.closeButton?.removeEventListener('click', this.closeModal);
    this.modal?.removeEventListener('transitionend', this.handleTransitionEnd);
    document.removeEventListener('click', this.handleClickOutside);
  }
}

// Register the custom element
customElements.define('size-chart-modal', SizeChartModal);
